import type { SuggestionResponse } from 'api/__GENERATED';
import * as R from 'remeda';

// Maps a single SuggestionResponse DTO to Data.Suggestion.
// Returns undefined if id or status is missing — those rows can't be keyed downstream.
function toSuggestion(dto: SuggestionResponse): Data.Suggestion | undefined {
  const {
    id,
    improvementAreaId,
    title,
    problemStatement,
    solutionProposal,
    status,
    createdBy,
    createdAt,
    sasUris,
  } = dto;

  if (!R.isDefined(id)) return undefined;
  if (!R.isDefined(status)) return undefined;
  if (!R.isDefined(createdAt)) return undefined;

  const suggestion: Data.Suggestion = {
    id,
    improvementAreaId: improvementAreaId ?? null,
    name: title ?? '',
    actionIds: [], // not returned by the API
    problemStatement: problemStatement ?? '',
    solutionProposal: solutionProposal ?? '',
    status: status.toUpperCase() as Data.Suggestion['status'],
    reporter: createdBy ?? '',
    created: new Date(createdAt).getTime(),
    imageUris: sasUris ?? [],
  };

  return suggestion;
}

export { toSuggestion };
